import React, { useState, useEffect } from "react";
import { Table, Form, FormGroup, Label, Input, Button, Row, Col, Card, CardBody } from "reactstrap";
import DatePicker from "react-datepicker";
import Select from 'react-select';
import { useFormik } from "formik";
import * as Yup from "yup";
import "react-datepicker/dist/react-datepicker.css";
import {
  fetchQualifications,
} from "store/actions";
import Swal from 'sweetalert2';
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import CustomSelect from "components/Common/custom-select";

const qualificationOptions = [{ label: "Bachelor's", value: "bachelor" }, { label: "Master's", value: "master" }];
const specializationOptions = [{ label: "Computer Science", value: "cs" }, { label: "Mechanical", value: "mech" }];
const modeOfStudyOptions = [{ label: "Full-time", value: "full-time" }, { label: "Part-time", value: "part-time" }];
const statusOptions = [{ label: "Issued", value: "issued" }, { label: "Returned", value: "returned" }];
const approvedByOptions = [{ label: "HR", value: "hr" }, { label: "Manager", value: "manager" }];

const validationSchema = Yup.object().shape({
  qualification: Yup.object().required("Qualification is required"),
  yearOfPassing: Yup.number().required("Year of Passing is required"),
  university: Yup.string().required("University/Institute/Board is required"),
  percentage: Yup.number().min(0).max(100).required("Percentage/CGPA is required"),
  specialization: Yup.object().required("Specialization is required"),
  modeOfStudy: Yup.object().required("Mode of Study is required"),
  referenceNo: Yup.string().required("Reference No is required"),
  file: Yup.mixed().required("File upload is required"),
});

const EmployeeOthers = ({ onChange }) => {
const dispatch = useDispatch();
const [authDetails, setAuthDetails] = useState(null);
const { 
    qualifications, 
    loading,
    error, 
  } = useSelector((state) => ({
    qualifications: state.QualificationMaster?.qualifications,
    
    loading: state.QualificationMaster?.loading,
    error: state.QualificationMaster?.error,
  }));


  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchQualifications(unitId));
  }, [dispatch]);

  const [formData, setFormData] = useState({
    qualification: "",
    university: "",
    course: "",
    year: "",
    percentage: "",
    mode: "",
    referenceNo: "",
    file: null,
  });
  const [formWorkExp, setFormWorkExp] = useState({
    companyName: "",
    fromDate: "",
    toDate: "",
    designation: "",
    reportedTo: "",
    reasonForChange: "",
    file: null,
  });
  const [formEquipment, setFormEquipment] = useState({
    description: "",
    equipmentNo: "",
    issueDate: "",
    make: "",
    value: "",
    status: "",
    returnDate: "",
    approvedBy: "",
    file: null,
  });

  const [educationList, setEducationList] = useState([formData]);
  const [workExperienceList, setWorkExperienceList] = useState([formWorkExp]);
  const [equipmentList, setEquipmentList] = useState([formEquipment]);

  const handleAddWorkExperienceRow = () => {
    setWorkExperienceList([...workExperienceList, {
      companyName: "",
      fromDate: "",
      toDate: "",
      designation: "",
      reportedTo: "",
      reasonForChange: "",
      file: null,
    }]);
  };

  const handleRemoveWorkExperienceRow = (index) => {
    setWorkExperienceList(workExperienceList.filter((_, i) => i !== index));
  };

  const handleWorkExpChange = (field, value, index) => {
    const newWorkExperienceList = [...workExperienceList];
    newWorkExperienceList[index][field] = value;
    setWorkExperienceList(newWorkExperienceList);
    onChange(newWorkExperienceList[index]);
  };

  const handleAddEquipmentRow = () => {
    setEquipmentList([...equipmentList, {
      description: "",
      equipmentNo: "",
      issueDate: "",
      make: "",
      value: "",
      status: "",
      returnDate: "",
      approvedBy: "",
      file: null,
    }]);
  };

  const handleRemoveEquipmentRow = (index) => {
    setEquipmentList(equipmentList.filter((_, i) => i !== index));
  };

  const handleEquipmentChange = (field, value, index) => {
    const newEquipmentList = [...equipmentList];
    newEquipmentList[index][field] = value;
    setEquipmentList(newEquipmentList);
    onChange(newEquipmentList[index]);
  };

  // Add Education Row
  const handleAddEducationRow = () => {
    setEducationList([...educationList, {
      qualification: "",
      university: "",
      course: "",
      year: "",
      percentage: "",
      mode: "",
      referenceNo: "",
      file: null,
    }]);
  };

  // Remove Education Row
  const handleRemoveEducationRow = (index) => {
    setEducationList(educationList.filter((_, i) => i !== index));
  };

  const handleEducationChange = (field, value, index) => {
    const newEducationList = [...educationList];
    newEducationList[index][field] = value;
    setEducationList(newEducationList);
    onChange(newEducationList[index]);
  };

  const handleFileChangeEducation = (e, index) => {
    const file = e.target.files[0];

    // Ensure that the educationList is initialized (in case it's empty)
    if (!educationList || educationList.length <= index) {
      // Initialize the list with empty rows if necessary
      const newEducationList = [...educationList];
      newEducationList[index] = {
        qualification: "",
        university: "",
        course: "",
        year: "",
        percentage: "",
        mode: "",
        referenceNo: "",
        file: null, // Add the file property to the new row
      };
      setEducationList(newEducationList);
    }

    // Update the file for the specified index
    const updatedEducationList = [...educationList];
    updatedEducationList[index].file = file;

    setEducationList(updatedEducationList);
  };


  const handleFileChangeWorkExp = (e, index) => {
    const file = e.target.files[0];
    const updatedWorkExperience = [...workExperienceList];
    updatedWorkExperience[index].file = file;
    setWorkExperienceList(updatedWorkExperience);
  };

  const handleFileChangeEquipment = (e, index) => {
    const file = e.target.files[0];
    const updatedEquipmentList = [...equipmentList];
    updatedEquipmentList[index].file = file;
    setEquipmentList(updatedEquipmentList);
  };

  const handleViewFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
  };


  const handleDownloadFile = (file) => {
    const fileURL = URL.createObjectURL(file);
    const link = document.createElement("a");
    link.href = fileURL;
    link.download = file.name; // Set the file name as the downloaded file
    link.click();
  };

  useEffect(() => {
    onChange({ educationList, workExperienceList, equipmentList });
  }, [educationList, workExperienceList, equipmentList, onChange]);

  // select custome style
  const SelectcustomStyles = {
    control: (base) => ({
      ...base,
      maxheight: 33.1,
      minHeight: 33.1,
      // overflow: "scroll",
    }),
    indicatorsContainer: (base) => ({
      ...base,
      padding: "0", // Match the padding for both dropdown and clear indicator
    }),
    dropdownIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Ensure consistent padding for dropdown indicator
    }),
    clearIndicator: (base) => ({
      ...base,
      padding: "2px 8px", // Adjust padding for clear indicator to match dropdown
    }),
  };

  return (
    <>
      <Form>
        <Row>
          <Col md={12} className="mb-3">
            <h5 style={{ color: "#0bb2d4", fontWeight: "bold" }}>Education Qualification</h5>
            <div className="tablewrapper">
              <div className="employee-table">
                <Table bordered>
                  <thead>
                    <tr>
                      <th style={{ width: "5%", textAlign: "center", cursor: "pointer" }}>
                        <i className="mdi mdi-plus-circle font-size-18 text-primary" onClick={handleAddEducationRow}></i>
                      </th>
                      <th style={{ width: "15%" }}>Qualification</th>
                      <th style={{ width: "20%" }}>University/Institute/Board</th>
                      <th style={{ width: "15%" }}>Course</th>
                      <th style={{ width: "10%" }}>Year</th>
                      <th style={{ width: "10%" }}>% / CGPA</th>
                      <th style={{ width: "10%" }}>Mode</th>
                      <th style={{ width: "10%" }}>Reference No</th>
                      <th style={{ width: "20%" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {educationList.map((edu, index) => (
                      <tr key={index}>
                        <td style={{ textAlign: "center" }}>
                          <i
                            className="mdi mdi-close-circle font-size-18 text-danger"
                            onClick={() => handleRemoveEducationRow(index)}
                          ></i>
                        </td>
                        <td>
                        {/* <Select
                            id={`qualification-${edu.id}`}
                            name={`qualification-${edu.id}`}
                            styles={SelectcustomStyles}
                            options={(qualifications || []).map(cat => ({
                              value: cat.Quali_id.toString(),  // Ensure value is a string
                              label: cat.Qualific_Name
                            }))}
                            value={(qualifications || []).find(option => option.value === edu.qualification?.toString()) || null} // Fix type mismatch
                            onChange={(selectedOption) => handleEducationChange("qualification", selectedOption?.value, index)}
                          /> */}
<Select
styles={SelectcustomStyles} 
  id={`qualification-${edu.id}`}
  name={`qualification-${edu.id}`}
  options={(qualifications || []).map((qual) => ({
    value: qual.Quali_id.toString(), // Ensure value is a string
    label: qual.Qualific_Name,
  }))}
  value={
    edu.qualification
      ? qualifications.find((qual) => qual.Quali_id.toString() === edu.qualification.toString()) 
        ? { 
            value: edu.qualification, 
            label: qualifications.find((qual) => qual.Quali_id.toString() === edu.qualification.toString()).Qualific_Name 
          }
        : null
      : null
  }
  onChange={(selectedOption) => handleEducationChange("qualification", selectedOption?.value, index)}
/>




                        </td>
                        <td>
                          <Input
                            type="text"
                            value={edu.university}
                            onChange={(e) => handleEducationChange("university", e.target.value, index)}
                          />
                        </td>
                        <td>
                          {/* <Select
                            styles={SelectcustomStyles}
                            options={specializationOptions}
                            value={specializationOptions.find(option => option.value === edu.course) || ""}
                            onChange={(selectedOption) => handleEducationChange("course", selectedOption.value, index)}
                          /> */}
                          <Input
                            type="text"
                            value={edu.course}
                            onChange={(e) => handleEducationChange("course", e.target.value, index)}
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            value={edu.year}
                            onChange={(e) => handleEducationChange("year", e.target.value, index)}
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            value={edu.percentage}
                            onChange={(e) => handleEducationChange("percentage", e.target.value, index)}
                          />
                        </td>
                        <td>
                          <Select
                            styles={SelectcustomStyles}
                            options={modeOfStudyOptions}
                            value={modeOfStudyOptions.find(option => option.value === edu.mode) || ""}
                            onChange={(selectedOption) => handleEducationChange("mode", selectedOption.value, index)}
                          />
                        </td>
                        <td>
                          <Input
                            type="text"
                            value={edu.referenceNo}
                            onChange={(e) => handleEducationChange("referenceNo", e.target.value, index)}
                          />
                        </td>
                        <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                          <input
                            type="file"
                            id={`education-upload-${index}`}
                            onChange={(e) => handleFileChangeEducation(e, index)}
                            style={{ display: 'none' }}
                          />
                          <i
                            className="mdi mdi-cloud-upload font-size-18 text-info"
                            style={{ cursor: 'pointer', marginRight: '10px' }}
                            onClick={() => document.getElementById(`education-upload-${index}`).click()}
                          ></i>
                          {edu.file && (
                            <>
                              <i
                                className="mdi mdi-eye font-size-18 text-info"
                                style={{ cursor: 'pointer', marginRight: '10px' }}
                                onClick={() => handleViewFile(edu.file)}
                              ></i>
                              <i
                                className="mdi mdi-cloud-download font-size-18 text-primary"
                                style={{ cursor: 'pointer' }}
                                onClick={() => handleDownloadFile(edu.file)}
                              ></i>
                            </>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-3">
            <h5 style={{ color: "#0bb2d4", fontWeight: "bold" }}>Work Experience</h5>
            <div className="tablewrapper">
            <div className="employee-table">
            <Table bordered>
              <thead>
                <tr>
                  <th style={{ width: "5%", textAlign: "center", cursor: "pointer" }}>
                    <i className="mdi mdi-plus-circle font-size-18 text-primary" onClick={handleAddWorkExperienceRow}></i>
                  </th>
                  <th style={{ width: "15%" }}>Company Name</th>
                  <th style={{ width: "15%" }}>From Date</th>
                  <th style={{ width: "15%" }}>To Date</th>
                  <th style={{ width: "15%" }}>Designation</th>
                  <th style={{ width: "15%" }}>Reported To</th>
                  <th style={{ width: "15%" }}>Reason for Change</th>
                  <th style={{ width: "10%" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {workExperienceList.map((workExp, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="mdi mdi-close-circle font-size-18 text-danger"
                        onClick={() => handleRemoveWorkExperienceRow(index)}
                      ></i>
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={workExp.companyName}
                        onChange={(e) => handleWorkExpChange("companyName", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="date"
                        value={workExp.fromDate}
                        onChange={(e) => handleWorkExpChange("fromDate", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="date"
                        value={workExp.toDate}
                        onChange={(e) => handleWorkExpChange("toDate", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={workExp.designation}
                        onChange={(e) => handleWorkExpChange("designation", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={workExp.reportedTo}
                        onChange={(e) => handleWorkExpChange("reportedTo", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={workExp.reasonForChange}
                        onChange={(e) => handleWorkExpChange("reasonForChange", e.target.value, index)}

                      />
                    </td>
                    <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <input
                        type="file"
                        id={`experience-upload-${index}`}
                        onChange={(e) => handleFileChangeWorkExp(e, index)}
                        style={{ display: 'none' }}
                      />
                      <i
                        className="mdi mdi-cloud-upload font-size-18 text-info"
                        style={{ cursor: 'pointer', marginRight: '10px' }}
                        onClick={() => document.getElementById(`experience-upload-${index}`).click()}
                      ></i>
                      {workExp.file && (
                        <>
                          <i
                            className="mdi mdi-eye font-size-18 text-info"
                            style={{ cursor: 'pointer', marginRight: '10px' }}
                            onClick={() => handleViewFile(workExp.file)}
                          ></i>
                          <i
                            className="mdi mdi-cloud-download font-size-18 text-primary"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDownloadFile(workExp.file)}
                          ></i>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
                {/* Add New Row */}
                {/* <tr>
    <td></td>
    <td>
      <Input type="text" value={formWorkExp.companyName} onChange={(e) => handleWorkExpChange("companyName", e.target.value)} />
    </td>
    <td>
      <Input type="date" value={formWorkExp.fromDate} onChange={(e) => handleWorkExpChange("fromDate", e.target.value)} />
    </td>
    <td>
      <Input type="date" value={formWorkExp.toDate} onChange={(e) => handleWorkExpChange("toDate", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formWorkExp.designation} onChange={(e) => handleWorkExpChange("designation", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formWorkExp.reportedTo} onChange={(e) => handleWorkExpChange("reportedTo", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formWorkExp.reasonForChange} onChange={(e) => handleWorkExpChange("reasonForChange", e.target.value)} />
    </td>
    <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
        <input
          type="file"
          id={`file-upload-new`}
          onChange={(e) => handleFileChangeWorkExp(e, workExperienceList.length)}
          style={{ display: 'none' }}
        />
        <i
          className="mdi mdi-cloud-upload font-size-18 text-info"
          style={{ cursor: 'pointer', marginRight: '10px' }}
          onClick={() => document.getElementById(`file-upload-new`).click()}
        ></i>
      </td>
  </tr> */}
              </tbody>
            </Table>
            </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="mb-3">
            <h5 style={{ color: "#0bb2d4", fontWeight: "bold" }}>Employee Equipment</h5>
            <div className="tablewrapper">
            <div className="employee-table">
            <Table bordered>
              <thead>
                <tr>
                  <th style={{ width: "5%", textAlign: "center", cursor: "pointer" }}>
                    <i className="mdi mdi-plus-circle font-size-18 text-primary" onClick={handleAddEquipmentRow}></i>
                  </th>
                  <th style={{ width: "15%" }}>Description</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Equipment No</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Issue Date</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Make</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Value</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Status</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Return Date</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Approved By</th> {/* Set width as percentage */}
                  <th style={{ width: "10%" }}>Action</th> {/* Set width as percentage */}
                </tr>
              </thead>
              <tbody>
                {equipmentList.map((equipment, index) => (
                  <tr key={index}>
                    <td style={{ textAlign: "center" }}>
                      <i
                        className="mdi mdi-close-circle font-size-18 text-danger"
                        onClick={() => handleRemoveEquipmentRow(index)}
                      ></i>
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={equipment.description}
                        onChange={(e) => handleEquipmentChange("description", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={equipment.equipmentNo}
                        onChange={(e) => handleEquipmentChange("equipmentNo", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="date"
                        value={equipment.issueDate}
                        onChange={(e) => handleEquipmentChange("issueDate", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={equipment.make}
                        onChange={(e) => handleEquipmentChange("make", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Input
                        type="text"
                        value={equipment.value}
                        onChange={(e) => handleEquipmentChange("value", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Select
                        styles={SelectcustomStyles}
                        options={statusOptions}
                        value={statusOptions.find(option => option.value === equipment.status) || ""}
                        onChange={(selectedOption) => handleEquipmentChange("status", selectedOption.value, index)}
                      />
                    </td>
                    <td>
                      <Input
                        type="date"
                        value={equipment.returnDate}
                        onChange={(e) => handleEquipmentChange("returnDate", e.target.value, index)}

                      />
                    </td>
                    <td>
                      <Select
                        styles={SelectcustomStyles}
                        options={approvedByOptions}
                        value={approvedByOptions.find(option => option.value === equipment.approvedBy) || ""}
                        onChange={(selectedOption) => handleEquipmentChange("approvedBy", selectedOption.value, index)}
                      />
                    </td>
                    <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
                      <input
                        type="file"
                        id={`equipment-file-upload-${index}`}
                        onChange={(e) => handleFileChangeEquipment(e, index)}
                        style={{ display: 'none' }}
                      />
                      <i
                        className="mdi mdi-cloud-upload font-size-18 text-info"
                        style={{ cursor: 'pointer', marginRight: '10px' }}
                        onClick={() => document.getElementById(`equipment-file-upload-${index}`).click()}
                      ></i>
                      {equipment.file && (
                        <>
                          <i
                            className="mdi mdi-eye font-size-18 text-info"
                            style={{ cursor: 'pointer', marginRight: '10px' }}
                            onClick={() => handleViewFile(equipment.file)}
                          ></i>
                          <i
                            className="mdi mdi-cloud-download font-size-18 text-primary"
                            style={{ cursor: 'pointer' }}
                            onClick={() => handleDownloadFile(equipment.file)}
                          ></i>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
                {/* Add New Equipment Row */}
                {/* <tr>
    <td></td>
    <td>
      <Input type="text" value={formEquipment.description} onChange={(e) => handleEquipmentChange("description", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formEquipment.equipmentNo} onChange={(e) => handleEquipmentChange("equipmentNo", e.target.value)} />
    </td>
    <td>
      <Input type="date" value={formEquipment.issueDate} onChange={(e) => handleEquipmentChange("issueDate", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formEquipment.make} onChange={(e) => handleEquipmentChange("make", e.target.value)} />
    </td>
    <td>
      <Input type="text" value={formEquipment.value} onChange={(e) => handleEquipmentChange("value", e.target.value)} />
    </td>
    <td>
      <Select
styles={SelectcustomStyles} 
        options={statusOptions} 
        value={formEquipment.status ? { label: formEquipment.status, value: formEquipment.status } : null} 
        onChange={(selectedOption) => handleEquipmentChange("status", selectedOption.value)} 
      />
    </td>
    <td>
      <Input type="date" value={formEquipment.returnDate} onChange={(e) => handleEquipmentChange("returnDate", e.target.value)} />
    </td>
    <td>
      <Select
styles={SelectcustomStyles} 
        options={approvedByOptions} 
        value={formEquipment.approvedBy ? { label: formEquipment.approvedBy, value: formEquipment.approvedBy } : null} 
        onChange={(selectedOption) => handleEquipmentChange("approvedBy", selectedOption.value)} 
      />
    </td>
    <td style={{ textAlign: 'center', display: 'flex', justifyContent: 'center' }}>
        <input
          type="file"
          id={`equipment-file-upload-${0}`}
          onChange={(e) => handleFileChangeEquipment(e, 0)}
          style={{ display: 'none' }}
        />
        <i
          className="mdi mdi-cloud-upload font-size-18 text-info"
          style={{ cursor: 'pointer', marginRight: '10px' }}
          onClick={() => document.getElementById(`equipment-file-upload-${0}`).click()}
        ></i>
      </td>
  </tr> */}
              </tbody>
            </Table>
            </div>
            </div>
          </Col>
        </Row>
      </Form>
    </>
  );
};

export default EmployeeOthers;
